import { create } from 'zustand'

interface PageState {
  // 헤더에 표시될 페이지 부제목 (예: '개별 클래스 관리', '클래스 관리')
  pageSubtitle: string | null
  setPageSubtitle: (subtitle: string | null) => void
}

export const usePageStore = create<PageState>((set) => ({
  pageSubtitle: null,
  setPageSubtitle: (subtitle) => set({ pageSubtitle: subtitle }),
}))

